// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__25yNu","label":"Category_label__1wajv","content":"Category_content__1eIPg","header":"Category_header__37C28","location":"Category_location__7eWq-"};